import { render, staticRenderFns } from "./NascidoLegado.vue?vue&type=template&id=3ae7ca74&"
import script from "./NascidoLegado.vue?vue&type=script&lang=js&"
export * from "./NascidoLegado.vue?vue&type=script&lang=js&"
import style0 from "./NascidoLegado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports